<template>
    <div>
        <v-dialog v-if="isMobile"
                  v-model="menu"
                  ref="menu"
                  :close-on-content-click="false"
                  :return-value.sync="input"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  width="290px"
                  persistent>

            <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="displayedDates"
                              outlined
                              dense
                              hide-details
                              readonly
                              tabindex="-1"
                              v-bind="attrs"
                              v-on="on"
                              :error="error"
                              :label="formatMenuText($t('datePicker.dateRangeLabel'))"
                              :aria-label="$t('datePicker.dateRangeLabel')"
                              prepend-inner-icon="mdi-calendar"
                              append-icon="mdi-triangle-small-down"
                              @click:append="on.click"></v-text-field>
            </template>

            <v-date-picker v-if="!isReset"
                           v-model="input"
                           scrollable
                           range
                           actions
                           :selected-items-text="displayedHeaderDates"
                           :allowed-dates="allowedDates"
                           :locale="locale"
                           @input="onInput">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="onCancel">{{formatMenuText($t('cancel'))}}</v-btn>
                <v-btn color="primary" @click="onSave">{{formatMenuText($t('ok'))}}</v-btn>
            </v-date-picker>
        </v-dialog>

        <v-menu v-if="!isMobile"
                v-model="menu"
                ref="menu"
                :close-on-content-click="false"
                :return-value.sync="input"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="displayedDates"
                              outlined
                              dense
                              hide-details
                              readonly
                              tabindex="-1"
                              v-bind="attrs"
                              v-on="on"
                              :error="error"
                              :label="formatMenuText($t('datePicker.dateRangeLabel'))"
                              :aria-label="$t('datePicker.dateRangeLabel')"
                              prepend-inner-icon="mdi-calendar"
                              append-icon="mdi-triangle-small-down"
                              @click:append="on.click"></v-text-field>
            </template>

            <v-date-picker v-if="!isReset"
                           v-model="input"
                           scrollable
                           range
                           actions
                           :selected-items-text="displayedHeaderDates"
                           :allowed-dates="allowedDates"
                           :locale="locale"
                           @input="onInput"
                           v-click-outside="resetComponent">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="onCancel">{{formatMenuText($t('cancel'))}}</v-btn>
                <v-btn color="primary" @click="onSave">{{formatMenuText($t('ok'))}}</v-btn>
            </v-date-picker>
        </v-menu>
    </div>
</template>

<style scoped>
    .v-date-picker-title__date {
        font-size: 16px !important;
        text-align: center !important;
        font-weight: bold !important;
    }
    .v-date-picker-title__year {
        display: none !important;
    }

    /* Override accessibility constraints for date picker layout */
    .v-date-picker-table__date {
        min-width: auto !important;
        min-height: auto !important;
        display: inline-block !important;
    }

    .v-date-picker-table__date--selected,
    .v-date-picker-table__date--disabled {
        min-width: auto !important;
        min-height: auto !important;
    }

    /* Reduce calendar size */
    /deep/ .v-date-picker {
        max-width: 300px !important;
    }

    /deep/ .v-date-picker-table {
        width: 100% !important;
        margin: 0 !important;
        padding: 4px !important;
    }

    /deep/ .v-date-picker-table tbody {
        margin: 0 !important;
    }

    /deep/ .v-date-picker-table tr {
        margin: 0 !important;
        height: auto !important;
    }

    /deep/ .v-date-picker-table__date {
        padding: 0px !important;
        height: 28px !important;
        width: 28px !important;
        font-size: 11px !important;
        margin: 2px !important;
        min-width: 28px !important;
        min-height: 28px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    /deep/ .v-date-picker-table__date--selected,
    /deep/ .v-date-picker-table__date--disabled {
        padding: 0px !important;
        height: 28px !important;
        width: 28px !important;
        margin: 2px !important;
    }

    /deep/ .v-date-picker-header {
        padding: 4px 8px !important;
        margin: 0 !important;
    }

    /deep/ .v-date-picker-title {
        padding: 4px 8px !important;
        margin: 0 !important;
        min-height: auto !important;
    }

    /deep/ .v-picker__body {
        padding: 0 !important;
    }

    /deep/ .v-picker {
        max-width: 300px !important;
    }
</style>

<script>
    import moment from "moment";

    export default {
        name: "DatePicker",
        props: {
            value: {
                type: [ Array, String]
            },
            minDate: {
                type: String
            },
            locale: {
                type: String
            },
            error: {
                type: Boolean,
                default: false
            },
            maxDaysInterval: {
                type: Number,
                default: 730
            }
        },
        data() {
            return {
                menu: false,
                input: this.value,
                minAllowedDate: this.minDate ? this.formatDateRemoveTime(this.minDate) : undefined,
                maxDate: undefined,
                isReset: false
            }
        },
        computed: {
            displayedDates() {
                if (this.input?.length === 2) {
                    return this.formatDateRemoveTime(this.input[0]) + ' - ' + this.formatDateRemoveTime(this.input[1]);
                }
                else {
                    return '';
                }
                
            },
            displayedHeaderDates() {
                if (this.input?.length === 2) {
                    var date1 = this.formatHeaderDate(new Date(this.input[0]));
                    var date2 = this.formatHeaderDate(new Date(this.input[1]))

                    return date1 + ' - ' + date2;
                }
                else {
                    return '';
                }
            },
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },
        },
        watch: {
            value: {
                deep: true,
                handler() {
                    this.input = this.value;
                }
                
            },
            minDate(val) {
                this.minAllowedDate = val ? this.formatDateRemoveTime(val) : undefined;
            },
            locale(val) {
                moment.locale(val);
            }
        },
        created() {
            moment.locale(this.locale);
        },
        methods: {
            formatMenuText(text) {
                if (!text) return text;

                // Check the titleCase setting from the current experience
                const titleCase = this.$experience.titleCase !== false; // default to true if not set

                if (titleCase) {
                    // Title case: capitalize first letter of all words
                    return text.split(' ').map(word => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join(' ');
                } else {
                    // Sentence case: only capitalize first letter of first word
                    // But preserve acronyms
                    const words = text.split(' ');
                    return words.map((word, index) => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        if (index === 0) {
                            // First word: capitalize first letter
                            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                        } else {
                            // Other words: all lowercase
                            return word.toLowerCase();
                        }
                    }).join(' ');
                }
            },
            allowedDates(val) {
                if (!this.minAllowedDate)
                    return true;
                
                var valDate = new Date(val);
                var tempMinAllowedDate = new Date(this.formatDateRemoveTime(this.minAllowedDate));

                if (this.maxDate)
                    return valDate.getTime() >= tempMinAllowedDate.getTime() && valDate.getTime() < this.maxDate;

                return valDate.getTime() >= tempMinAllowedDate.getTime();
            },
            onInput() {
                if (this.input?.length === 1) {
                    let d1 = new Date(this.input[0]);
                    this.maxDate = moment(d1, "YYYY-MM-DD").add(this.maxDaysInterval, 'days');

                    if (!this.minAllowedDate)
                        this.minAllowedDate = new Intl.DateTimeFormat('fr-CA').format(new Date(this.input[0]));
                }
                if (this.input?.length === 2) {
                    this.maxDate = undefined;
                    this.minAllowedDate = undefined;
                    this.input.sort();
                }
            },
            onSave() {
                this.$refs.menu.save(this.input);
                this.$emit('input', this.input);
                this.resetComponent();
            },
            onCancel() {
                this.input = this.value;
                this.menu = false;
                this.resetComponent();
            },
            formatDateRemoveTime(val) {
                if (val) {
                    return val.split('T')[0];
                }
                return null;
            },
            formatHeaderDate(val) {
                if (val) {
                    let options = {
                        weekday: "short",
                        month: "short",
                        day: "numeric"
                    }
                    let headerLocale = "en-US";
                    if (this.locale == 'fr')
                        headerLocale = "fr-CA";

                    return new Intl.DateTimeFormat(headerLocale, options).format(val);
                }
                return null
            },
            resetComponent() {
                this.minAllowedDate = undefined;
                this.isReset = true
                this.$nextTick(() => {
                    this.isReset = false
                })
            }
        },
    }
</script>